import type {Locale, LocaleData} from '@sail/intl';
import {defaultLocale} from '@sail/intl';

export const getLocaleData = async (locale?: Locale): Promise<LocaleData> => {
  if (locale) {
    try {
      // eslint-disable-next-line no-unsanitized/method
      const importResult = await import(
        /* webpackChunkName: "[request]" */ `../../intl/${locale}.ts`
      );
      return importResult.locale;
    } catch (error) {
      // Only throw the error in cases that the file should exist
      if (process.env.INTL_ENABLED || process.env.NODE_ENV !== 'development') {
        throw error;
      }
    }
  }

  return {locale: defaultLocale, messages: {}};
};
